import React from 'react'
import {
  SettingsNestedMenu,
  SettingsNestedMenuProps,
} from 'src/editor/layout/sidebar/settings/settings-nested-menu'
import { FormElementMenuItem } from './form-elements-menu-item'
import { Trash02Icon } from 'src/editor/shared/icons/trash-02-icon'
import { twJoin } from 'tailwind-merge'

interface FormElementsSettingsNestedMenuItemProps
  extends Pick<SettingsNestedMenuProps, 'isOpen' | 'onClose'> {
  menuTitle: string
  children: React.ReactNode
  icon: () => React.ReactNode
  onDelete: (event: React.MouseEvent<SVGSVGElement>) => void
}

export const FormElementsSettingsNestedMenuItem = ({
  menuTitle,
  children,
  icon,
  onDelete,
  isOpen,
  onClose,
}: FormElementsSettingsNestedMenuItemProps) => {
  return (
    <SettingsNestedMenu
      className="m-0"
      menuTitle={menuTitle}
      menuButtonClassName={twJoin(
        'relative mb-2 p-0',
        '[&:has(span>svg:hover)]:hover:bg-none [&:hover>span>svg]:opacity-100',
      )}
      menuButtonLabel={
        <>
          <FormElementMenuItem title={menuTitle} icon={icon} />
          <Trash02Icon
            className="absolute top-[7px] right-[34px] text-iconError opacity-0 transition-opacity duration-150"
            onClick={onDelete}
          />
        </>
      }
      isOpen={isOpen}
      onClose={onClose}
    >
      {children}
    </SettingsNestedMenu>
  )
}
